

    import { MinMaxFilter, MinMaxSelection, isMinMaxSelection, MinMaxOption } from '@/catalog-app/types';
    import { defineComponent, PropType, inject } from 'vue';
    import { useStore } from '@/catalog-app/store';

    export default defineComponent({

        name: 'FilterMinMax',

        props: {
            filter: {
                type: Object as PropType<MinMaxFilter>,
                required: true,
            }
        },

        setup() {

            const store = useStore();
            const state = store.state;
            const loading = inject('loading') as boolean;

            return {
                store,
                state,
                loading,
            }
        },

        computed: {

            selectedMin: {
                get(): number|null {
                    const sel = this.state.selected[this.filter.name] as MinMaxSelection;
                    return Array.isArray(sel) ? sel[0] : null;
                },
                set(value: number|string|null) {
                    if (value !== this.selectedMin) {
                        if (value === '') {
                            value = null;
                        } else if (typeof value === 'string') {
                            return;
                        }
                        this.store.setSelectionMinMax(this.filter.name, [value, this.selectedMax]);
                    }
                }
            },
            selectedMax: {
                get(): number|null {
                    const sel = this.state.selected[this.filter.name] as MinMaxSelection;
                    return Array.isArray(sel) ? sel[1] : null;
                },
                set(value: number|string|null) {
                    if (value !== this.selectedMax) {
                        if (value === '') {
                            value = null;
                        } else if (typeof value === 'string') {
                            return;
                        }
                        this.store.setSelectionMinMax(this.filter.name, [this.selectedMin, value]);
                    }
                }
            },

            lower(): number {
                return this.filter.range ? this.filter.range[0] : 0;
            },

            upper(): number {
                return this.filter.range ? this.filter.range[1] : 1;
            },

            step(): number {
                if (typeof this.filter.step !== 'undefined') {
                    return this.filter.step;
                }
                const steps = [0.1, 0.25, 0.5, 1, 5, 10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000];
                const dist = this.upper - this.lower;
                return steps.find(x => dist / x <= 16) || 50000;
            },

            places(): number {
                if (typeof this.filter.places !== 'undefined') {
                    return this.filter.places;
                } else if (this.step <= 0.25) {
                    return 2;
                } else if (this.step <= 0.5) {
                    return 1;
                } else {
                    return 0;
                }
            },

            /** Options for min and max */
            options(): number[] {
                const opts = [] as number[];
                const lowerStart = Math.floor(this.lower / this.step) * this.step;
                const upperEnd = Math.ceil(this.upper / this.step) * this.step;
                // add options
                for (let x=lowerStart; x <= upperEnd; x += this.step) {
                    opts.push(x);
                }
                return opts;
            },

            minOptions(): MinMaxOption[] {
                return this.options.map(o => ({
                    num: o,
                    name: `${o.toFixed(this.places)} ${this.filter.unit}`,
                    disabled: this.selectedMax !== null && o > this.selectedMax,
                }));
            },

            maxOptions(): MinMaxOption[] {
                return this.options.map(o => ({
                    num: o,
                    name: `${o.toFixed(this.places)} ${this.filter.unit}`,
                    disabled: this.selectedMin !== null && o < this.selectedMin,
                }));
            }

        },

    });

